<template>
    <span v-if="isOneDay(start, end)">
        {{ dateToString(start) }}
    </span>
    <span v-else>{{ dateRangeToString(start, end) }}</span>
</template>

<script>
import moment from 'moment';
import tz from 'moment-timezone';
import dateToString from '~/utils/dateToString';
export default {
    name: 'DateRange',
    props: {
        start: {
            type: String,
            required: true,
            default: () => '',
        },
        end: {
            type: String,
            required: true,
            default: () => '',
        },
    },
    methods: {
        dateToString(date) {
            return dateToString(date, true, true);
        },
        isOneDay(_start, _end) {
            let start = new Date(_start);
            if (!_end) return true;

            let end = new Date(_end);
            return (
                start.getDate() === end.getDate() &&
                start.getMonth() === end.getMonth() &&
                start.getFullYear() === end.getFullYear()
            );
        },
        dateRangeToString(_start, _end) {
            let start = new Date(_start);
            let end = new Date(_end);
            let sameYear,
                sameMonth = false;

            if (start.getFullYear() === end.getFullYear()) sameYear = true;
            if (start.getMonth() === end.getMonth()) sameMonth = true;

            let mStart = moment(_start);
            let mEnd = moment(_end);

            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const timeString = mStart.tz(timeZone).format('LT z');

            let dateString = '';

            if (sameYear) {
                if (sameMonth) {
                    dateString = start.getDate() + ' - ' + mEnd.format('D MMMM');
                }
                dateString = mStart.format('D MMMM') + ' - ' + mEnd.format('D MMMM');
            }

            dateString = mStart.format('D MMMM') + ' - ' + mEnd.format('D MMMM');

            return dateString + ', ' + timeString;
        },
    },
};
</script>

<style></style>
